module.exports = __webpack_public_path__ + "static/media/craigCalver.1356624b.jpg";